import { mockTheme } from 'venn-utils';
import { theme } from '../global';
import { userIsAuthenticated } from '../user';
import { mockRecoilState, setRecoilState } from 'venn-test/recoil';
import type { StudioPrintSettingsContextValue } from 'venn-components';
import { apiPrintSettings } from '../studio/fonts/workspaceDefaults';

const mockOrganizationPrintSettings = {
  organizationPrintSettings: {
    organizationName: 'org display name',
  },
} as StudioPrintSettingsContextValue;

/** A simple array of common states to kickstart testing that involves Recoil and potentially Studio.  */
export const authAndThemeState = () =>
  Object.freeze([
    setRecoilState({ state: userIsAuthenticated, value: true }),
    setRecoilState({ state: theme, value: mockTheme }),
    mockRecoilState({
      state: apiPrintSettings,
      value: mockOrganizationPrintSettings.organizationPrintSettings,
    }),
  ]);
